import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import useContactForm from '../../hooks/useContactForm';
import { useEffect } from 'react';

function Contact() {
  const { t } = useTranslation();

  const { form, loading, error, success, handleChange, sendEmail, setError, setSuccess } =
    useContactForm();

  const { executeRecaptcha } = useGoogleReCaptcha();
  // console.log('recaptcha ready', executeRecaptcha);

  // ❗ Dodajemo timeout za poruke
  useEffect(() => {
    if (error || success) {
      const timer = setTimeout(() => {
        setError(null);
        setSuccess(null);
      }, 5000); // 5 sekundi
      return () => clearTimeout(timer);
    }
  }, [error, success, setError, setSuccess]);

  return (
    <div id="top">
      <PageHeader
        title={t('contactPage.title')}
        page={t('contactPage.page')}
        pageUrl={'contact'}
      />

      <div className="page">
        <div className="container">
          <div className="row">
            {/* LEFT SIDE FORM */}
            <div className="contact-info col-lg-7">
              <h4>{t('contactPage.title_send_message')}</h4>

              {/* FORM START */}
              <form
                id="contact_form"
                onSubmit={async e => {
                  e.preventDefault();

                  if (!executeRecaptcha) {
                    // console.warn('reCAPTCHA not ready');
                    return;
                  }

                  const token = await executeRecaptcha('contact_form');

                  sendEmail(token);
                }}
              >
                <div className="form-group">
                  <div className="row">
                    {/* NAME */}
                    <div className="col-md-6">
                      <label>
                        {t('common.name')}
                        <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="form-control input-field"
                        required
                        value={form.name}
                        onChange={handleChange}
                      />
                    </div>

                    {/* EMAIL */}
                    <div className="col-md-6">
                      <label>
                        {t('contactPage.email_address')}
                        <span className="required">*</span>
                      </label>
                      <input
                        type="email"
                        name="email"
                        className="form-control input-field"
                        required
                        value={form.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    {/* SUBJECT */}
                    <div className="col-md-12">
                      <label>{t('contactPage.subject')}</label>
                      <input
                        type="text"
                        name="subject"
                        className="form-control input-field"
                        value={form.subject}
                        onChange={handleChange}
                      />
                    </div>

                    {/* MESSAGE */}
                    <div className="col-md-12">
                      <label>
                        {t('contactPage.message')}
                        <span className="required">*</span>
                      </label>
                      <textarea
                        name="message"
                        className="textarea-field form-control"
                        rows="4"
                        required
                        value={form.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>

                  {/* SUBMIT BUTTON */}
                  <button
                    type="submit"
                    id="submit_btn"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading
                      ? t('contactPage.sending')
                      : t('contactPage.send_message')}
                  </button>
                </div>

                {/* SUCCESS & ERROR MESSAGES */}
                <div id="contact_results" className="mt-3">
                  {error && (
                    <p style={{ color: 'red' }}>
                      {t('contactPage.error_message')}
                    </p>
                  )}
                  {success && (
                    <p style={{ color: 'green' }}>
                      {t('contactPage.success_message')}
                    </p>
                  )}
                </div>
              </form>
              {/* FORM END */}
            </div>

            {/* RIGHT SIDE INFO */}
            <div className="col-lg-4 offset-lg-1 h-50 card bg-secondary res-margin">
              <div className="contact-info text-light">
                <h5>{t('contactPage.information')}</h5>
                <p>{t('contactPage.info_desc')}</p>
                <ul className="list-unstyled mt-5 list-contact">
                  <li className="h7">
                    <i className="fa fa-envelope margin-icon"></i>
                    <a href="mailto:pawfriendssarajevo@gmail.com">
                      pawfriendssarajevo@gmail.com
                    </a>
                  </li>
                  <li className="h7">
                    <i className="fa fa-map-marker margin-icon"></i>
                    Sarajevo, {t('common.bih')}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
